import "./CuratedServices.module.css";
import Header from "@/reusable_sections/Header";
import ExquisitePlanningDesign from "./sections/ExquisitePlanningDesign";
import ThePlanningJourney from "./sections/ThePlanningJourney";
import CulinaryExcellence from "./sections/CulinaryExcellence";
import Footer from "@/reusable_sections/Footer";
export default function CuratedServicesPage() {
  return <div>
      <Header />
      <ExquisitePlanningDesign />
      <ThePlanningJourney />
      <CulinaryExcellence />
      <Footer />
    </div>;
}